import { createContext, useContext, useState, type ReactNode } from "react";

/**
 * Ponte entre o layout (produtor/admin) e o ProducerEventPanel para o "modo foco".
 * O layout registra o elemento do slot na sidebar via ref; o painel lê esse
 * elemento e porta sua navegação para lá. Usa ref callback (não getElementById)
 * para evitar corridas de timing entre árvores irmãs.
 */
interface EventFocusSlotValue {
  slot: HTMLElement | null;
  setSlot: (el: HTMLElement | null) => void;
}

const EventFocusSlotContext = createContext<EventFocusSlotValue>({
  slot: null,
  setSlot: () => {},
});

export function EventFocusSlotProvider({ children }: { children: ReactNode }) {
  const [slot, setSlot] = useState<HTMLElement | null>(null);
  return (
    <EventFocusSlotContext.Provider value={{ slot, setSlot }}>
      {children}
    </EventFocusSlotContext.Provider>
  );
}

export function useEventFocusSlot() {
  return useContext(EventFocusSlotContext);
}
